var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuelTank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2323_102565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8252 18.5666H2.0252V4.5666L3.5852 3.1566L2.5052 2.2666H0.0751953V0.766602H3.0752L4.7152 2.1466L6.2552 0.766602H15.8252V18.5666ZM3.5252 17.0666H14.3252V2.2666H6.8252L3.5252 5.2666V17.0666ZM12.2352 15.3266H5.6352V13.8266H7.0952C6.89937 13.4895 6.79622 13.1065 6.79622 12.7166C6.79622 12.3267 6.89937 11.9438 7.0952 11.6066L8.9752 8.5066L10.7452 11.6266C10.9391 11.9644 11.0411 12.3471 11.0411 12.7366C11.0411 13.1261 10.9391 13.5088 10.7452 13.8466V13.8966H12.2152L12.2352 15.3266ZM8.4152 12.3266C8.34358 12.4311 8.3004 12.5524 8.28988 12.6787C8.27936 12.8049 8.30187 12.9317 8.3552 13.0466C8.42463 13.1305 8.51172 13.198 8.61025 13.2443C8.70877 13.2907 8.81631 13.3147 8.9252 13.3147C9.03408 13.3147 9.14162 13.2907 9.24014 13.2443C9.33867 13.198 9.42576 13.1305 9.4952 13.0466C9.55839 12.9371 9.59166 12.813 9.59166 12.6866C9.59166 12.5602 9.55839 12.4361 9.4952 12.3266L8.9852 11.4266L8.4152 12.3266ZM12.2752 5.4666H8.1152V3.9666H12.2752V5.4666Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2323_102565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 17.81,
    fill: "white",
    transform: "translate(0.0751953 0.766602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelTank);
export default __webpack_public_path__ + "static/media/fuel-tank.fba0ad7b924952a4001bf7fcc5db25c0.svg";
export { ForwardRef as ReactComponent };